import { Fragment as ReactFragment } from 'react'
import { analyserTexte } from './texteRiche'

/** Rend un texte d'annonce : paragraphes, sauts de ligne et gras. */
export function TexteRiche({ texte, className }: { texte: string; className?: string }) {
  const paragraphes = analyserTexte(texte)
  return (
    <>
      {paragraphes.map((lignes, ip) => (
        <p key={ip} className={className}>
          {lignes.map((fragments, il) => (
            <ReactFragment key={il}>
              {il > 0 && <br />}
              {fragments.map((f, i) =>
                f.gras ? <strong key={i} className="font-semibold">{f.texte}</strong> : <ReactFragment key={i}>{f.texte}</ReactFragment>,
              )}
            </ReactFragment>
          ))}
        </p>
      ))}
    </>
  )
}
